import React from 'react'
import './Footer.css'
import Github from '../../assets/github.png'
import Instagram from '../../assets/instagram.png'
import LinkedIn from '../../assets/linkedin.png'
import logo from '../../assets/logo.png'
const Footer = () => {
  return (
   <div className="footer-container">
        <hr />
        <div className="footer">
          <div className="blur f-blur1"></div>
          <div className="blur f-blur2"></div>
            <div className="social-links " >
              <img src={Github} alt="" />
              <img src={Instagram} alt="" />
              <img src={LinkedIn} alt="" />
            </div>
       
            <div className="logo-f">
            <img src={logo} alt="" />
            </div>
        </div>
   </div>
  )
}

export default Footer
